<ng-container [ngSwitch]="layout$ | async">
  <app-admin-layout *ngSwitchCase="AppLayoutType.Admin"> </app-admin-layout>

  <router-outlet *ngSwitchCase="AppLayoutType.Blank"> </router-outlet>
</ng-container>
